import React, { useCallback, useRef, useState, useMemo, useEffect } from 'react';
// import { IResolveParams, LoginSocialGoogle, LoginSocialMicrosoft, TypeCrossFunction } from 'reactjs-social-login';
import { IResolveParams, LoginSocialMicrosoft } from 'reactjs-social-login';
//import { useLinkedIn } from 'react-linkedin-login-oauth2';
import { toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import { SocialEnum, SocialEnumKeyType } from '../../types/auth';
import { authService } from '../../lib/api/auth';
import { goToRoom } from './utils';
import { isCaptchaEnabled, microsoftClientId } from '../../config/constants';
import MediaLayout from './media-layout';
import { routes } from '../routes/routes-names';
import lock from '../../assets/img/padlock.png';
import { Message, SweetAlertTitle, WarningIcon } from '../../lib/constants/messages';
import { authType } from '../../lib/auth-type';
import microsoftLogo from '../../assets/img/Microsoft.png';
import googleLogo from '../../assets/img/Google.png';
import { history } from '../../history';
import Swal from 'sweetalert2';
import queryString from 'query-string';
import { registrationLocationConstants } from '../../lib/constants/constants';
import { Helmet } from 'react-helmet';
import { Field, FieldProps, Formik, FormikProps } from 'formik';
import useInitialErrors from '../../hooks/formik-initial-errors';
import { object as objectYup, string as stringYup } from 'yup';
import getValue from 'lodash/get';
import ReCAPTCHA from 'react-google-recaptcha';
import { getSiteKey } from '../../lib/utils/common-functions';
import ResetPassword from './resetPassword';
import ManagerInvitationSignUp from './invitations/managerInvitationSignUp';
import { ManagerInvitationAPIFormType } from '../../types/managerInvitation';
import { CandidateInvitationAPIFormType } from '../../types/CandidateInvitation';
import CandidateInvitationSignUp from './invitations/candidateInvitationSignUp';
// import { appInsights } from '../../config/app-insights';
import GoogleLoginComponent from './google-login';
import { MicrosoftLoginComponent } from './microsoft-login';
import { useAppDispatch } from '../../redux/reduxhooks';
import { marketIntegrationService } from '../../lib/api/marketplaceIntegration';

type AuthSocialProps = {
    goToRegistration: () => void;
};

const initialFormData = {
    email: '',
    password: '',
    recaptcha: '',
};

const AuthSocial: React.FC<AuthSocialProps> = ({ goToRegistration }) => {
    const [loading, setLoading] = useState('');
    const [suspended, setSuspended] = useState(false);
    const [superAdminNotAllowed, setsuperAdminNotAllowed] = useState(false);
    const [accountRejected, setAccountRejected] = useState(false);
    const [showPass, setShowPass] = useState(false);
    const [base64PassString, setBase64PassString] = useState('');
    const [customEmail, setCustomEmail] = useState('');
    const [customPass, setCustomPass] = useState('');
    const [showResetPassTab, setShowResetPassTab] = useState<boolean>(false);
    const [showManagerInviteForm, setShowManagerInviteForm] = useState(false);
    const [managerInviteSignInData, setManagerInviteSignInData] = useState<ManagerInvitationAPIFormType>();
    const [showCandidateInviteForm, setShowCandidateInviteForm] = useState(false);
    const [candidateInviteSignInData, setCandidateInviteSignInData] = useState<CandidateInvitationAPIFormType>();
    const [verified, setVerified] = useState(false);
    const [token, setToken] = useState('');
    const urlPath = history.location;

    const navigate = useNavigate();

    const { ConfirmManagerInvitationId, ConfirmCandidateInvitationId } = queryString.parse(urlPath.search);

    const dispatch = useAppDispatch();

    const captchaEnabled = String(isCaptchaEnabled).toLowerCase() === 'true' ? true : false;

    const profileFormData = useMemo(() => {}, []);

    const initialErrors = useInitialErrors(profileFormData, getValidationSchema(captchaEnabled));

    const signIn = useCallback(
        async (provider: SocialEnumKeyType, profile: any, customEmail?: string, customPass?: string) => {
            const email = getEmail(provider, profile);
            try {
                setLoading(provider);
                let data;
                if (urlPath.pathname === '/registration/social') {
                    data = await authService.socialSignIn({
                        Email: email || customEmail,
                        AuthType: SocialEnum[provider],
                        Token: profile.id_token || '',
                        Location: registrationLocationConstants.IsSocial || '',
                        Password: customPass,
                    });
                }

                if (data) {
                    authType.setAuthType(provider);
                    await goToRoom(data, dispatch, navigate);
                }
            } catch (error: any) {
                if (error.response.status === 401) {
                    setLoading('');
                    Swal.fire({
                        title: SweetAlertTitle.Sorry,
                        text: Message.EmailNotRegisteredWithOfferX,
                        icon: WarningIcon,
                        confirmButtonText: 'Ok',
                    });
                } else if (error.response.status === 400) {
                    if (error.response.data.error.message === Message.OnlySuperAdminsAllowed) {
                        setsuperAdminNotAllowed(true);
                    } else if (error.response.data.error.message === Message.AccountRejected) {
                        setAccountRejected(true);
                        setLoading('');
                    } else if (error.response.data.error.message === Message.CredentialMismatch) {
                        Swal.fire({
                            icon: WarningIcon,
                            text: Message.InvalidCreds,
                        });
                        setLoading('');
                    } else if (error.response.data.error.message === Message.CustomAuthUnAvailable) {
                        Swal.fire({
                            title: SweetAlertTitle.Sorry,
                            icon: WarningIcon,
                            confirmButtonText: 'Ok',
                            text: Message.RegisteredWithGoogle,
                        });
                        setLoading('');
                    } else if (error.response.data.error.message === Message.JoinThroughLink) {
                        Swal.fire({
                            title: SweetAlertTitle.Sorry,
                            icon: WarningIcon,
                            confirmButtonText: 'Ok',
                            text: Message.JoinViaInvitation,
                        });
                        setLoading('');
                    } else if (error.response.data.error.message.includes(Message.PrimaryEmail)) {
                        Swal.fire({
                            title: SweetAlertTitle.Sorry,
                            icon: WarningIcon,
                            confirmButtonText: 'Ok',
                            text: error.response.data.error.message,
                        });
                        setLoading('');
                    } else {
                        setSuspended(true);
                        setLoading('');
                    }
                } else {
                    toast.error(Message.AuthenticationError);
                    setLoading('');
                }
            }
        },
        [dispatch, urlPath.pathname]
    );

    useEffect(() => {
        if (customPass) {
            const convertToBase64 = () => {
                const encodedString = btoa(customPass);
                setBase64PassString(encodedString);
            };

            convertToBase64();
        }
    }, [customPass]);

    useEffect(() => {
        const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        if (ConfirmManagerInvitationId) {
            if (typeof ConfirmManagerInvitationId === 'string' && guidPattern.test(ConfirmManagerInvitationId)) {
                setShowManagerInviteForm(true);
            } else if (Array.isArray(ConfirmManagerInvitationId)) {
                // Handle the case when it's an array of strings or null values
            } else {
                // Handle other cases here, e.g., when it's null or some other unexpected type
            }
        }
    }, [ConfirmManagerInvitationId]);

    useEffect(() => {
        const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        if (ConfirmCandidateInvitationId) {
            if (typeof ConfirmCandidateInvitationId === 'string' && guidPattern.test(ConfirmCandidateInvitationId)) {
                setShowCandidateInviteForm(true);
            } else if (Array.isArray(ConfirmCandidateInvitationId)) {
                // Handle the case when it's an array of strings or null values
            } else {
                // Handle other cases here, e.g., when it's null or some other unexpected type
            }
        }
    }, [ConfirmCandidateInvitationId]);

    useEffect(() => {
        if (managerInviteSignInData) {
            const { email, newPassword } = managerInviteSignInData;

            signIn('CustomAuth', '', email, newPassword);
        } else if (candidateInviteSignInData) {
            const { email, newPassword } = candidateInviteSignInData;

            signIn('CustomAuth', '', email, newPassword);
        }
    }, [managerInviteSignInData, candidateInviteSignInData, signIn]);

    return (
        <>
            {urlPath.pathname === '/registration/social' ? (
                <>
                    <Helmet>
                        <title>
                            OfferX - Sign In | Be A Part Of The Modern Hiring Process Without Candidate Ghosting
                        </title>
                        <meta
                            name="description"
                            content="Simplify your registration process on OfferX. Seamlessly join using your social media accounts, gaining instant access to a vast network of employers and job opportunities."
                        />
                    </Helmet>
                    <MediaLayout>
                        {suspended ? (
                            <div className="w-100 p-4 text-center">
                                <img loading="lazy" src={lock} className="img-fluid mb-4" alt="OfferX Logo" />
                                <h4 className="fs-24 fw-700">Your account is suspended</h4>
                                <p className="mb-2 fs-16">Please reach out to our customer support team at</p>
                                <a href="mailto:support@offerx.in" className="btn-link me-4 text-decoration-none">
                                    <i className="bi bi-envelope" /> support@offerx.in
                                </a>
                                {/*<a href="tel:+914048512310" className="btn-link text-decoration-none">
                            <i className="bi bi-telephone" /> +91 40 48512310
                        </a>*/}
                            </div>
                        ) : superAdminNotAllowed ? (
                            <div className="w-100 p-4 text-center">
                                <img loading="lazy" src={lock} className="img-fluid mb-4" alt="OfferX Logo" />
                                <h4 className="fs-24 fw-700">You are already a user in OfferX Admin portal.</h4>
                                <div className="d-flex justify-content-center">
                                    <p className="mb-2 fs-16 me-2">Please login to</p>
                                    <a
                                        rel="noreferrer"
                                        href="https://admin.offerx.in"
                                        target="_blank"
                                        className="btn-link me-4 text-decoration-none"
                                    >
                                        admin.offerx.in
                                    </a>
                                </div>
                            </div>
                        ) : accountRejected ? (
                            <div className="w-100 p-4 text-center">
                                <img loading="lazy" src={lock} className="img-fluid mb-4" alt="OfferX Logo" />
                                <h4 className="fs-24 fw-700">Your account verification was not successful.</h4>
                                <p className="mb-2 fs-16">
                                    We regret to inform you that your account verification was not successful. Please
                                    reach out to our customer support team at
                                    <a href="mailto:support@offerx.in" className="btn-link mx-2  text-decoration-none">
                                        <i className="bi bi-envelope" /> support@offerx.in
                                    </a>
                                    for any questions.
                                </p>
                                {/*<a href="tel:+914048512310" className="btn-link text-decoration-none">
                            <i className="bi bi-telephone" /> +91 40 48512310
                        </a>*/}
                            </div>
                        ) : (
                            <>
                                {!showResetPassTab ? (
                                    <div className="mx-auto d-block" style={{ maxWidth: '600px' }}>
                                        <div className="card lt-shadow-sm">
                                            <div className="login-card-body">
                                                <div className="flex-column">
                                                    {!showManagerInviteForm && !showCandidateInviteForm ? (
                                                        <div>
                                                            <div className="w-100 mb-4">
                                                                <h1 className="fs-28 fw-600 mb-2">Log In</h1>
                                                                <div className="fs-14 lt-text-secondary">
                                                                    Don't Have An Account Yet?
                                                                    <Link to={routes.signUp}>
                                                                        <span className="lt-text-primary-alt">
                                                                            {' '}
                                                                            Sign Up
                                                                        </span>
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                            <Formik
                                                                onSubmit={() => {}}
                                                                enableReinitialize
                                                                initialValues={initialFormData}
                                                                validationSchema={getValidationSchema(captchaEnabled)}
                                                                initialErrors={initialErrors}
                                                            >
                                                                {(formikProps: FormikProps<any>) => {
                                                                    const {
                                                                        handleSubmit,
                                                                        values,
                                                                        isSubmitting,
                                                                        setFieldTouched,
                                                                        setFieldValue,
                                                                    } = formikProps;

                                                                    const siteKey = getSiteKey();

                                                                    return (
                                                                        <form onSubmit={handleSubmit}>
                                                                            <>
                                                                                <div className="mb-3">
                                                                                    <label
                                                                                        className="fs-14 fw-400 mb-2"
                                                                                        htmlFor="email"
                                                                                    >
                                                                                        Email{' '}
                                                                                        <span className="lt-text-error">
                                                                                            *
                                                                                        </span>
                                                                                    </label>
                                                                                    <Field name="email">
                                                                                        {(fieldProps: FieldProps) => {
                                                                                            const { field, form } =
                                                                                                fieldProps;
                                                                                            const error =
                                                                                                getValue(
                                                                                                    form.touched,
                                                                                                    field.name
                                                                                                ) &&
                                                                                                getValue(
                                                                                                    form.errors,
                                                                                                    field.name
                                                                                                );
                                                                                            return (
                                                                                                <>
                                                                                                    <input
                                                                                                        type="email"
                                                                                                        value={
                                                                                                            field.value
                                                                                                        }
                                                                                                        onChange={(
                                                                                                            ev
                                                                                                        ) => {
                                                                                                            setFieldTouched(
                                                                                                                field.name
                                                                                                            );
                                                                                                            setFieldValue(
                                                                                                                field.name,
                                                                                                                ev
                                                                                                                    .target
                                                                                                                    .value
                                                                                                            );

                                                                                                            setCustomEmail(
                                                                                                                ev
                                                                                                                    .target
                                                                                                                    .value
                                                                                                            );
                                                                                                        }}
                                                                                                        className="form-control h-44"
                                                                                                        placeholder="Enter Email"
                                                                                                        id="email"
                                                                                                    />
                                                                                                    {typeof error ===
                                                                                                        'string' && (
                                                                                                        <small className="text-danger fs-12">
                                                                                                            {error}
                                                                                                        </small>
                                                                                                    )}
                                                                                                </>
                                                                                            );
                                                                                        }}
                                                                                    </Field>
                                                                                </div>
                                                                                <div className="mb-3">
                                                                                    <label
                                                                                        className="fs-14 fw-400 mb-2"
                                                                                        htmlFor="password"
                                                                                    >
                                                                                        Password{' '}
                                                                                        <span className="lt-text-error">
                                                                                            *
                                                                                        </span>
                                                                                    </label>
                                                                                    <Field name="password">
                                                                                        {(fieldProps: FieldProps) => {
                                                                                            const { field, form } =
                                                                                                fieldProps;
                                                                                            const error =
                                                                                                getValue(
                                                                                                    form.touched,
                                                                                                    field.name
                                                                                                ) &&
                                                                                                getValue(
                                                                                                    form.errors,
                                                                                                    field.name
                                                                                                );
                                                                                            return (
                                                                                                <>
                                                                                                    <div className="position-relative">
                                                                                                        <input
                                                                                                            type={`${
                                                                                                                showPass
                                                                                                                    ? 'text'
                                                                                                                    : 'password'
                                                                                                            }`}
                                                                                                            // value={field.value}
                                                                                                            onChange={(
                                                                                                                ev
                                                                                                            ) => {
                                                                                                                setFieldTouched(
                                                                                                                    field.name
                                                                                                                );
                                                                                                                setFieldValue(
                                                                                                                    field.name,
                                                                                                                    ev
                                                                                                                        .target
                                                                                                                        .value
                                                                                                                );

                                                                                                                setCustomPass(
                                                                                                                    ev
                                                                                                                        .target
                                                                                                                        .value
                                                                                                                );
                                                                                                            }}
                                                                                                            className="form-control h-44"
                                                                                                            placeholder="Enter Password"
                                                                                                            id="password"
                                                                                                            style={{
                                                                                                                paddingRight:
                                                                                                                    '2rem',
                                                                                                            }}
                                                                                                        />
                                                                                                        <i
                                                                                                            onClick={() =>
                                                                                                                setShowPass(
                                                                                                                    !showPass
                                                                                                                )
                                                                                                            }
                                                                                                            className={`bi ${
                                                                                                                showPass
                                                                                                                    ? 'bi-eye'
                                                                                                                    : ' bi-eye-slash'
                                                                                                            } password-toggle cursor-pointer`}
                                                                                                        ></i>
                                                                                                    </div>
                                                                                                    {typeof error ===
                                                                                                        'string' && (
                                                                                                        <small className="text-danger fs-12">
                                                                                                            {error}
                                                                                                        </small>
                                                                                                    )}
                                                                                                </>
                                                                                            );
                                                                                        }}
                                                                                    </Field>
                                                                                </div>
                                                                                {captchaEnabled && (
                                                                                    <div className="mb-3">
                                                                                        <Field name="recaptcha">
                                                                                            {(
                                                                                                fieldProps: FieldProps
                                                                                            ) => {
                                                                                                const { field, form } =
                                                                                                    fieldProps;
                                                                                                const error =
                                                                                                    getValue(
                                                                                                        form.touched,
                                                                                                        field.name
                                                                                                    ) &&
                                                                                                    getValue(
                                                                                                        form.errors,
                                                                                                        field.name
                                                                                                    );
                                                                                                return (
                                                                                                    <div>
                                                                                                        <ReCAPTCHA
                                                                                                            sitekey={
                                                                                                                siteKey
                                                                                                            }
                                                                                                            onChange={(
                                                                                                                value
                                                                                                            ) => {
                                                                                                                setFieldTouched(
                                                                                                                    field.name
                                                                                                                );
                                                                                                                setFieldValue(
                                                                                                                    field.name,
                                                                                                                    value
                                                                                                                );
                                                                                                            }}
                                                                                                        />
                                                                                                        {typeof error ===
                                                                                                            'string' && (
                                                                                                            <small className="text-danger fs-12">
                                                                                                                {error}
                                                                                                            </small>
                                                                                                        )}
                                                                                                    </div>
                                                                                                );
                                                                                            }}
                                                                                        </Field>
                                                                                    </div>
                                                                                )}
                                                                                <button
                                                                                    onClick={() => {
                                                                                        const shouldSubmit =
                                                                                            captchaEnabled
                                                                                                ? Boolean(
                                                                                                      values.recaptcha
                                                                                                  )
                                                                                                : true;

                                                                                        if (base64PassString) {
                                                                                            if (shouldSubmit) {
                                                                                                signIn(
                                                                                                    'CustomAuth',
                                                                                                    '',
                                                                                                    values.email,
                                                                                                    base64PassString
                                                                                                );
                                                                                            }
                                                                                        } else {
                                                                                        }
                                                                                    }}
                                                                                    className="btn btn-primary w-100 h-44"
                                                                                    disabled={loading === 'CustomAuth'}
                                                                                >
                                                                                    {loading === 'CustomAuth' && (
                                                                                        <span className="spinner-border spinner-border-sm" />
                                                                                    )}{' '}
                                                                                    Log In
                                                                                </button>
                                                                            </>
                                                                        </form>
                                                                    );
                                                                }}
                                                            </Formik>
                                                            <div className="text-end">
                                                                <button
                                                                    onClick={() => {
                                                                        setShowResetPassTab(true);
                                                                    }}
                                                                    className="fs-14 mt-1 lt-text-primary-alt cursor-pointer text-decoration-underline"
                                                                >
                                                                    Forgot Password?
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ) : showManagerInviteForm ? (
                                                        <div>
                                                            <ManagerInvitationSignUp
                                                                ConfirmManagerInvitationId={
                                                                    ConfirmManagerInvitationId?.toString() || ''
                                                                }
                                                                setManagerInviteSignInData={setManagerInviteSignInData}
                                                            />
                                                        </div>
                                                    ) : showCandidateInviteForm ? (
                                                        <div>
                                                            <CandidateInvitationSignUp
                                                                ConfirmCandidateInvitationId={
                                                                    ConfirmCandidateInvitationId?.toString() || ''
                                                                }
                                                                setCandidateInviteSignInData={
                                                                    setCandidateInviteSignInData
                                                                }
                                                            />
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}

                                                   {!showManagerInviteForm && (
                                                    <>
                                                     <div className="social-or-line my-3">or</div>
                                                    <div className="mb-0  d-lg-flex d-md-flex d-block justify-content-between social-btns">
                                                        <div className="text-center mb-3">
                                                            {loading === 'microsoft' ? (
                                                                <>
                                                                    <button
                                                                        type="button"
                                                                        className="btn login-btn microsoft-btn text-start"
                                                                        disabled
                                                                    >
                                                                        <span className="microsoft-icon">
                                                                            <img
                                                                                src={microsoftLogo}
                                                                                width={20}
                                                                                alt="Microsoft logo"
                                                                            />
                                                                        </span>
                                                                        <span className="social-btn-text">
                                                                            Sign in with Microsoft
                                                                        </span>
                                                                    </button>
                                                                    <div className="new-spinner p-absolute">
                                                                        <div>
                                                                            <span className="spinner-border spinner-border-sm custom-spinner-border" />
                                                                        </div>
                                                                        <p className="fs-14 custom-loading-text">
                                                                            Loading
                                                                        </p>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <MicrosoftLoginComponent
                                                                    signIn={signIn}
                                                                    label="Sign in with Microsoft"
                                                                />
                                                            )}
                                                        </div>
                                                        <div className="text-center mb-3">
                                                            {loading === 'google' ? (
                                                                <>
                                                                    <button
                                                                        type="button"
                                                                        className="btn login-btn google-btn text-start"
                                                                        disabled
                                                                    >
                                                                        <span className="google-icon">
                                                                            <img
                                                                                src={googleLogo}
                                                                                width={20}
                                                                                alt="Google logo"
                                                                            />
                                                                        </span>
                                                                        <span className="google-text-margin social-btn-text">
                                                                            Sign in with Google
                                                                        </span>
                                                                    </button>
                                                                    <div className="new-spinner p-absolute">
                                                                        <div>
                                                                            <span className="spinner-border spinner-border-sm custom-spinner-border" />
                                                                        </div>
                                                                        <p className="fs-14 custom-loading-text">
                                                                            Loading
                                                                        </p>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <GoogleLoginComponent
                                                                    signIn={signIn}
                                                                    label="Sign in with Google"
                                                                />
                                                            )}
                                                        </div>
                                                    </div>
                                                    </>
                                                   )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <ResetPassword setShowResetPassTab={setShowResetPassTab} />
                                    </>
                                )}
                            </>
                        )}
                    </MediaLayout>
                </>
            ) : (
                <>
                    <div className="d-flex flex-column mb-4 pointer-events-none">
                        <div className="text-start mb-3">
                            {loading === 'microsoft' ? (
                                <>
                                    <button type="button" className="btn login-btn microsoft-btn text-start" disabled>
                                        <span className="microsoft-icon">
                                            <img loading="lazy" src={microsoftLogo} width={20} alt="Microsoft logo" />
                                        </span>
                                        <span className="social-btn-text">Sign up with Microsoft</span>
                                    </button>
                                    <div className="new-spinner p-absolute">
                                        <div>
                                            <span className="spinner-border spinner-border-sm custom-spinner-border" />
                                        </div>
                                        <p className="fs-14 custom-loading-text">Loading</p>
                                    </div>
                                </>
                            ) : (
                                <LoginSocialMicrosoft
                                    // ref={microsoftRef}
                                    client_id={microsoftClientId}
                                    redirect_uri={window.location.origin}
                                    onResolve={({ provider, data }: IResolveParams) => {
                                        if (provider === 'microsoft') {
                                            signIn(provider, data);
                                        }
                                    }}
                                    onReject={(err: any) => {}}
                                    scope="profile openid email User.Read"
                                >
                                    <button
                                        type="button"
                                        className="btn login-btn microsoft-btn pointer-events-all text-start"
                                    >
                                        <span className="microsoft-icon">
                                            <img loading="lazy" src={microsoftLogo} width={20} alt="Microsoft logo" />
                                        </span>
                                        <span className="social-btn-text">Sign up with Microsoft</span>
                                    </button>
                                </LoginSocialMicrosoft>
                            )}
                        </div>
                        <div className="text-start">
                            {loading === 'google' ? (
                                <>
                                    <button type="button" className="btn login-btn google-btn text-start" disabled>
                                        <span className="google-icon">
                                            <img loading="lazy" src={googleLogo} width={20} alt="Google logo" />
                                        </span>
                                        <span className="google-text-margin social-btn-text">Sign up with Google</span>
                                    </button>
                                    <div className="new-spinner p-absolute">
                                        <div>
                                            <span className="spinner-border spinner-border-sm custom-spinner-border" />
                                        </div>
                                        <p className="fs-14 custom-loading-text">Loading</p>
                                    </div>
                                </>
                            ) : (
                                <GoogleLoginComponent signIn={signIn} label="Sign in with Google" />
                            )}
                        </div>
                    </div>
                    <div className="w-100 m-auto fs-12 text-center lt-text-secondary">
                        By clicking sign up, you agree to the OfferX <br />{' '}
                        <a className="text-decoration-none" target="_blank" href="/legal/terms">
                            Terms &amp; Conditions
                        </a>
                        ,{' '}
                        <a className="text-decoration-none" target="_blank" href="/legal/privacy">
                            Privacy
                        </a>{' '}
                        and{' '}
                        <a className="text-decoration-none" target="_blank" href="/legal/privacy#Item-6">
                            Cookie policies.
                        </a>
                    </div>
                    <div className="text-center mt-4">
                        <p className="fs-12 text-center">
                            Already in OfferX?{' '}
                            <Link to={routes.signinSignup}>
                                <a className="lt-text-primary-alt cursor-pointer">Sign in</a>
                            </Link>
                        </p>
                    </div>
                </>
            )}
        </>
    );
};

export default AuthSocial;

export function getEmail(provider: SocialEnumKeyType, profile: any) {
    return SocialEnum[provider] === SocialEnum.microsoft
        ? profile?.email ||
              profile?.username ||
              profile?.idTokenClaims?.email ||
              profile?.idTokenClaims?.preferred_username
        : SocialEnum[provider] === SocialEnum.google
        ? profile?.email
        : SocialEnum[provider] === SocialEnum.linkedIn
        ? profile?.emailAddress
        : '';
}

const getValidationSchema = (captchaEnabled: boolean) =>
    objectYup().shape({
        recaptcha: captchaEnabled ? stringYup().nullable().required('Captcha is required.') : stringYup().nullable(),
        email: stringYup().required('Email is required.'),
        password: stringYup().required('Password is required.'),
    });
